module.exports = __webpack_public_path__ + "static/media/codepenclone.823a1bba.webp";